import React, { useEffect } from 'react'
// import { SandraQnA } from './SandraQnA';
// import ArrowIcon from '../../assets/SVGs/ArrowIcon';
import { useSearchParams } from "react-router-dom";
import { useTheme } from '../../context/ThemeContext';
import { customComponentNameMap } from '../../assets/SVGs/customIcons';
import MagicStar from '../../assets/SVGs/MagicStar';
import { useNavigate } from 'react-router-dom';
import { QUESTIONS } from './constants';
import MultipleMagicStar from '../../assets/SVGs/MultipleMagicStar';
import OvumForm from './OvumForm';
import SidebarLogo from '../../assets/SVGs/SidebarLogo';
import { useDispatch } from 'react-redux';
import { hideSideBar } from '../../store/sidebarSlice';
import { isOvum } from '../../utils/utils';
import LoadingOverlay from '../insurance/LoadingOverlay';
import { useAuthContext } from '../../context/AuthContext';
import { getMembershipEligibilityData, loggerAPI, sendInsuranceData } from '../../utils/apis';
import { isBCBSProvider } from '../../utils/insuranceUtils';

export default function OvumLandingPage() {
  const { theme } = useTheme();
  const [loading, setLoading] = React.useState<boolean>(true);
  const { Component1, Component2, Component3 } =
    customComponentNameMap[theme.logo];
  const navigate = useNavigate();
  const { setIsAuthenticated } = useAuthContext();
  const [searchParams] = useSearchParams();
  const dispatch = useDispatch()
  let traceId = "";
  useEffect(() => {
    if(isOvum()) {
      dispatch(hideSideBar())
      setLoading(true);
    }
  }, [isOvum])

  useEffect(() => {
    if(isOvum()) {
      setLoading(true);
      try {
        const firstName = searchParams.get("firstName");
        const lastName = searchParams.get("lastName");
        const dob = searchParams.get("dob");
        const membership = searchParams.get("membership");
        const provider = searchParams.get("provider");
        const state = searchParams.get("state");
        const email = searchParams.get("email");
        const phone = searchParams.get("phone");
        traceId = searchParams.get("traceId") || "";
        loggerAPI({
          traceId: traceId,
          event: "front-end-info",
          message: "Search params",
          timestamp: new Date().toISOString(),
          data: searchParams,
        });

        if( !firstName || !membership) {
          setLoading(false);
          return;
        }
        const formData = {
          firstName: firstName,
          lastName: lastName,
          email: email,
          phone: phone,
          dob: dob,
          insuranceCompany: provider,
          insuranceMemberId: membership,
          isInsuranceExist: true,
          state: state,
        }
        window?.history?.pushState({}, '', window.location.pathname);
        const apiPromise = sendInsuranceData(formData);
        apiPromise.then(async (response : any) => {
          let question = "";
          let metadata = {};
          const res: any = await getMembershipEligibilityData(state || "", provider || "", dob || "", membership || "");
          const insuranceVerification = res?.data?.isInsuranceVerified;
          const networkStatus = res?.data?.isNetworkCoverage;
          if (!insuranceVerification) {
            if(isBCBSProvider(provider)) {
              question = `Hi ${firstName}, I'm Sandra, your AI assistant for Ovum Health! Great news that you have a BCBS plan—Ovum Health is in the Blue Card program, but doesn’t have a local plan contract where you live. However, most plans allow you to see us in a different state via telehealth. Do you have an Anthem Blue Card in addition to your regular insurance card?`
              metadata = { networkstatus: "OUT", insurance_verfiication: "failed", landing_message: question, bcbs_tag: "yes"};
            } else if(networkStatus) {
              question = `Hi ${firstName}, I'm Sandra, your AI assistant for Ovum Health. Good news! We are in-network with your payer, but could not verify your plan. Sometimes this happens when it’s an employer sponsored plan, an HMO or a plan purchased from the marketplace. I’ll call your plan to verify your specific coverage. For me to complete that step, we ask that you book a free nursing consult. Would you like to see what’s available?`
              metadata = { networkstatus: "OUT", insurance_verfiication: "pass", landing_message: question, bcbs_tag: "no"};
            } else {
              question = `Hi ${firstName}, I'm Sandra, your AI assistant for Ovum Health. Looks like we aren’t yet in network with your plan, but we might be in the contracting phase. I can check that for you once you book a free nursing consult. Would you like to see what’s available?`
              metadata = { networkstatus: "OUT", insurance_verfiication: "failed", landing_message: question, bcbs_tag: "no"};
            }
          } else {
            if(networkStatus) {
              question = `Hi ${firstName}, I'm Sandra, your AI assistant for Ovum Health! Great news—Ovum Health is in-network for your plan. We offer a free nursing consult as the first step. Would you like to see what’s available?`
              metadata = { networkstatus: "IN", insurance_verfiication: "pass", landing_message: question, bcbs_tag: isBCBSProvider(provider) ? "yes" : "no"};
            } else {
              question = `Hi ${firstName}, I'm Sandra, your AI assistant for Ovum Health. It looks like we're pending as in-network, but you may have out-of-network benefits. I can check that for you once you book a free nursing consult. Would you like to see what’s available?`
              metadata = { networkstatus: "OUT", insurance_verfiication: "pass", landing_message: question, bcbs_tag: isBCBSProvider(provider) ? "yes" : "no"};
            }
          }
          navigate('/asksandra', {
            state: {
              question: question,
              date: Date.now(),
              metadata: metadata,
              onlyMessage: true
            },
            replace: true
          });
          setIsAuthenticated(true);
          setLoading(false);
        }).catch((error : any) => {
          loggerAPI({
            traceId: traceId || "",
            event: "front-end-error",
            message: "Error sending insurance data for the validation of the membership",
            timestamp: new Date().toISOString(),
            data: {
              error: error,
            },
          });
          navigate('/error');
          setLoading(false);
        });
      } catch (error) {
        loggerAPI({
          traceId: traceId || "",
          event: "front-end-error",
          message: "Error sending insurance data",
          timestamp: new Date().toISOString(),
          data: {
            error: error,
          },
        });
        navigate('/error');
        setLoading(false);
      }
    }
  }, [searchParams]);
  
  if(loading) {
    return <LoadingOverlay />;
  }

  return (
    <>
    <div className="min-h-[950px] md:min-h-screen overflow-hidden relative flex flex-col items-center bg-gray-10 p-4 md:p-8">
    <div className="flex justify-center items-center w-full md:justify-end md:h-auto"></div>
    <>
      <>
        <div className="flex md:mt-2 flex-col items-center mt-4">
          <MultipleMagicStar
            stopColor={theme['star-stopColor']}
            offsetStopColor={theme['star-stopOffsetColor']}
          />
          <h1
            className={`text-2xl md:text-3xl font-medium text-center mt-2 text-[${theme['p_color']}]`}
          >
            Ask me a billing question
          </h1>
          <div
            className={`text-center font-normal text-l p-2 rounded-lg space-x-2 md:text-2xl md:space-x-6 md:mt-2 md:mb-4 inline ${theme['home-subheading']} px-4 md:px-[180px]`}
          >
            Hi, I am Sandra at Ovum! Ask me any insurance, offers, pricing, estimate or bill related question!
          </div>
        </div>
      </>
      <div className="flex flex-wrap justify-center gap-4 px-4 md:px-[180px]">
        {QUESTIONS[theme.client].map((question, index) => (
          <button
            key={index}
            style={{
              background:
                'linear-gradient(100.06deg, #DCE1E8 12.16%, #CAD3E1 95.67%)',
            }}
            className={`flex flex-row items-center justify-center rounded-lg shadow-md px-4 py-2 
              bg-white text-gray-800 hover:bg-teal-50 hover:${theme['text-600']}`}
          >
            <MagicStar
              stopColor={theme['star-stopColor']}
              offsetStopColor={theme['star-stopOffsetColor']}
            />
            <span
              className="ml-2 text-sm sm:text-base lg:text-lg text-center truncate"
            >
              {question.question}
            </span>
          </button>
        ))}
      </div>
    </>
    <div className="static bottom-20 z-10 w-full max-w-[400px] md:max-w-auto md:w-auto md:min-w-[600px] md:bottom-auto">
      <OvumForm />
    </div>
    <div className="fixed bottom-20 md:bottom-0 right-45 md:right-0 w-[157px] hidden lg:flex lg:w-[257px] z-0">
      <Component3 />
    </div>
    <div className="fixed bottom-0 left-10 flex justify-end items-end hidden lg:flex">
      <Component1 />
      <div className="ml-5">
        <Component2 />
      </div>
    </div>


    <div className="absolute bottom-0 left-50 flex justify-end items-end hidden md:flex">
      <span className='flex justify-center items-center text-center font-medium gap-2 text-sm'>
        Powered by <SidebarLogo width={111} />
      </span>
    </div>
    </div>
  </>
  )
}
